import type { AlertRecord } from '../../api/useAllAlerts'
import type { UpdateAlertPayload } from '../../api/useUpdateAlert'

/**
 * Builds the body for an enable/disable toggle. Every field is sent explicitly
 * because the endpoint replaces the collections it receives — omitting the
 * contacts or tags would quietly clear them.
 *
 * `emails` and `phoneNumbers` are guarded rather than spread: alerts saved
 * before those fields existed come back null.
 */
export const buildAlertTogglePayload = (
  alert: AlertRecord,
  enabled: boolean,
): UpdateAlertPayload => ({
  enabled,
  title: alert.title,
  emails: Array.isArray(alert.emails) ? alert.emails : [],
  phoneNumbers: Array.isArray(alert.phoneNumbers) ? alert.phoneNumbers : [],
  templateName: alert.templateName,
  templateVariables: alert.templateVariables,
  tags: (alert.tags ?? []).map((tag) => tag.id),
})
